export default class AttackingStyles {
  static shortPlays = -1;
  static mixed = 0;
  static directPlays = 1;
}
